import React ,{ Component } from "react";
import Card from "../components/card";
import LedLight from "../components/ledLight";

export default class PreStories extends Component{
    render(){
        return(
            <>
                <div style={{background:"#282c34" , marginTop:"60px" , display:"flex" , justifyContent:"center" , alignItems:"center"} } className="container">
                    <div className="row">
                        {this.props.Cards.map(card=>{
                           return <Card key={card.id} Card={card} />
                        })}
                    </div>
                </div>
                <LedLight/>
            </>
        )
    }
}